var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded overflow-hidden h-full"},[_c('div',{staticClass:"board-canvas relative flex-grow h-full"},[_c('div',{class:[
        'board',
        'absolute',
        'inset-0',
        'select-none',
        'whitespace-nowrap',
        'space-x-1',
        'pb-2',
        'overflow-x-auto',
        'overflow-y-hidden',
      ]},[_vm._l((_vm.lists),function(list){return [_vm._t("default",null,{"list":list})]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }